<div class="table-responsive">
  <table class="table table-bordered mb-0">
    <thead class="table-light">
      <tr>
        <th>Paciente</th>
        <th>No. de Documento</th>
        <th>Fecha de Nacimiento</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>{{ patient().nombres }}</td>
        <td>{{ patient().documento }}</td>
        <td>{{ patient().fechaNacimiento }}</td>
      </tr>
    </tbody>
  </table>
</div>
